import React, { useState, useEffect, useRef } from "react";
// import IQAMAH from "../pages/main/pic/IQAMAH.mp3";
import { getNotes } from "../api";
import { fetchItems } from "../api";

import PrayerBoard from "../components/PrayerBoard";
import { getToday } from "../api";
import {
  todayMMDDYY,
  tomorrowMMDDYY,
  format12h,
  weekday,
  todayPretty,
  nowPretty,
  tomorrowPretty,
  hijriTodayEnglish,
  scheduleMidnightReload,
} from "../utils/date";
//email:micnytv@gmail.com
// Password: Micnytv@gmail.com@123

// samsung tv login: micnytv@gmail.com
// samsung tv password: MED$%#GehGHdf34
const azanAudio = new Audio("/azan.mp3"); // Put azan.mp3 in public folder

// import ddata from "./ddddata.json";
// import dataForFiveTimesColorBackground from "./dataForFiveTimesColor.json";

//

// function parseDateTimeFlexible(dateStr, timeStr) {
//   if (!dateStr || !timeStr) return null;
//   const parts = dateStr.split("/").map((p) => Number(p));
//   if (parts.length !== 3) return null;
//   let month, day, year;
//   // auto-detect: if first part > 12 assume DD/MM/YY, else MM/DD/YY
//   if (parts[0] > 12) {
//     // DD/MM/YY
//     day = parts[0];
//     month = parts[1];
//     year = 2000 + parts[2];
//   } else {
//     // MM/DD/YY
//     month = parts[0];
//     day = parts[1];
//     year = 2000 + parts[2];
//   }
//   const [hour, minute] = timeStr.split(":").map((s) => Number(s));
//   const dt = new Date(year, month - 1, day, hour, minute, 0, 0);
//   return dt;
// }

// returns duration in minutes for a given prayer key and day object
// function getDurationMinutes(prayerKey, dayObj) {
//   // prayerKey is like "Fajr_Iqamah", "Dhuhr_Iqamah", etc.
//   const base =
//     {
//       Fajr_Iqamah: 15,
//       Dhuhr_Iqamah: 10,
//       Asr_Iqamah: 10,
//       Maghrib_Iqamah: 12,
//       Isha_Iqamah: 15,
//     }[prayerKey] || 10;

//   // special Friday rule: if day is Friday and prayer is Dhuhr => 60
//   if (
//     prayerKey === "Dhuhr_Iqamah" &&
//     String(dayObj.Day || "")
//       .trim()
//       .toLowerCase() === "friday"
//   ) {
//     return 60;
//   }
//   return base;
// }
//উপরের পুরা টা হচ্ছে ১০ মিইট কালো স্ক্রীন এর জন্য

// Nicher pura ta arabic date er jonno

// Returns mathematic mod, not javascript mod
// e.g. gmod(-3, 2) returns 1, whereas -3%2 returns -1
function gmod(n, m) {
  return ((n % m) + m) % m;
}

/* @param {Date}   date   - optional, default is today
 ** @param {number} adjust - optiona, days to adjust date by
 */
function kuwaiticalendar(date, adjust) {
  var today = date ? new Date(+date) : new Date();
  if (adjust) {
    today.setDate(today.getDate() + +adjust);
  }

  var day = today.getDate();
  var month = today.getMonth();
  var year = today.getFullYear();
  var m = month + 1;
  var y = year;

  if (m < 3) {
    y -= 1;
    m += 12;
  }

  var a = Math.floor(y / 100);
  var b = 2 - a + Math.floor(a / 4);

  if (y < 1583) b = 0;
  if (y == 1582) {
    if (m > 10) b = -10;
    if (m == 10) {
      b = 0;
      if (day > 4) b = -10;
    }
  }

  var jd =
    Math.floor(365.25 * (y + 4716)) +
    Math.floor(30.6001 * (m + 1)) +
    day +
    b -
    1524;

  b = 0;
  if (jd > 2299160) {
    a = Math.floor((jd - 1867216.25) / 36524.25);
    b = 1 + a - Math.floor(a / 4);
  }

  var bb = jd + b + 1524;
  var cc = Math.floor((bb - 122.1) / 365.25);
  var dd = Math.floor(365.25 * cc);
  var ee = Math.floor((bb - dd) / 30.6001);
  day = bb - dd - Math.floor(30.6001 * ee);
  month = ee - 1;

  if (ee > 13) {
    cc += 1;
    month = ee - 13;
  }
  year = cc - 4716;
  var wd = gmod(jd + 1, 7) + 1;

  var iyear = 10631 / 30;
  var epochastro = 1948084;
  var epochcivil = 1948085;

  var shift1 = 8.01 / 60;

  var z = jd - epochastro;
  var cyc = Math.floor(z / 10631);
  z = z - 10631 * cyc;
  var j = Math.floor((z - shift1) / iyear);
  var iy = 30 * cyc + j;
  z = z - Math.floor(j * iyear + shift1);
  var im = Math.floor((z + 28.5001) / 29.5);

  if (im == 13) im = 12;
  var id = z - Math.floor(29.5001 * im - 29);

  return [
    day, //calculated day (CE)
    month - 1, //calculated month (CE)
    year, //calculated year (CE)
    jd - 1, //julian day number
    wd - 1, //weekday number
    id, //islamic date
    im - 1, //islamic month
    iy, //islamic year
  ];
}

function writeIslamicDate(date, adjustment) {
  var wdNames = [
    "Ahad",
    "Ithnin",
    "Thulatha",
    "Arbaa",
    "Khams",
    "Jumuah",
    "Sabt",
  ];
  var iMonthNames = [
    "Muharram",
    "Safar",
    "Rabi'ul Awwal",
    "Rabi'ul Akhir",
    "Jumadal Ula",
    "Jumadal Akhira",
    "Rajab",
    "Sha'ban",
    "Ramadan",
    "Shawwal",
    "Dhul Qa'ada",
    "Dhul Hijja",
  ];
  var iDate = kuwaiticalendar(date, adjustment);
  var outputIslamicDate =
    wdNames[iDate[4]] +
    ", " +
    iDate[5] +
    " " +
    iMonthNames[iDate[6]] +
    " " +
    iDate[7] +
    " AH";
  return outputIslamicDate;
}

// Uporer pura ta arabic date er jonno
// function excelDateToJSDate(excelSerial) {
//   const excelEpoch = new Date(1900, 0, 1); // Jan 1, 1900
//   const msPerDay = 1000 * 60 * 60 * 24;
//   const daysOffset = excelSerial - 1; // Excel counts Jan 1, 1900 as day 1
//   const jsDate = new Date(excelEpoch.getTime() + daysOffset * msPerDay);
//   return jsDate;
// }
//Convert Excel serial number to JS Date up

// Get next Friday from today
// const getNextFriday = () => {
//   const today = new Date();
//   const day = today.getDay(); // Sunday = 0, Friday = 5
//   const daysToAdd = (5 - day + 7) % 7 || 7; // Always go forward
//   const nextFriday = new Date(today);
//   nextFriday.setDate(today.getDate() + daysToAdd);
//   return nextFriday;
// };
//above finds next fiday

const formatTime = (date) => {
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  const minutesStr = minutes < 10 ? "0" + minutes : minutes;
  const secondsStr = seconds < 10 ? "0" + seconds : seconds;
  return hours + ":" + minutesStr + ":" + secondsStr + " " + ampm;
};
// Convert Excel time (e.g. 0.625) to AM/PM format below
// function excelTimeToAMPM(excelTime) {
//   const totalMinutes = Math.round(excelTime * 24 * 60);
//   let hours = Math.floor(totalMinutes / 60);
//   const minutes = totalMinutes % 60;

//   const ampm = hours >= 12 ? "PM" : "AM";
//   hours = hours % 12;
//   hours = hours === 0 ? 12 : hours;

//   const pad = (n) => String(n).padStart(2, "0");
//   return `${hours}:${pad(minutes)}:00 ${ampm}`;
// }

export default function Mobile() {
  const [data, setData] = useState(null);
  const [processed, setProcessed] = useState(null);
  const [tData, setTData] = useState(null);
  const [now, setNow] = useState(nowPretty());
  const [today, setToday] = useState(todayPretty());
  const [tomorroww, setTomorroww] = useState(tomorrowPretty());
  const [notes, setNotes] = useState([]);

  // const [now, setNow] = useState(new Date());

  // console.log(format12h(tData?.fajrIqamah));
  // console.log(data);
  // console.log(klk);

  //step1: below is for pulling today's data from backend api
  useEffect(() => {
    getToday(todayMMDDYY())
      .then(setData)
      // .runAfterData(data)
      .catch(() => {});
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  //above is for pulling  today's data from backend api

  // Step 2: Run your function only after data is ready
  useEffect(() => {
    if (data) {
      const output = runAfterData(data); // your custom function
      setProcessed(output); // store processed result
    }
  }, [data]); // ekhan e data change holei run hobe abong data ready thakle run hobe abong data er upor depend kore abong data pura load hole tar por next line ta run hobe

  // Example function that depends on data
  function runAfterData(data) {
    // do something with data
    // console.log(data);
  }

  // below is for pulling tomorrow's data from backend api
  useEffect(() => {
    getToday(tomorrowMMDDYY())
      .then(setTData)
      .catch(() => {});
    const timer = setInterval(() => setNow(nowPretty()), 1000);
    scheduleMidnightReload();
    return () => clearInterval(timer);
  }, []);
  // above is for pulling tomorrow's data from backend api

  //bellow is pulling all notes from backend
  useEffect(() => {
    loadNotes();
  }, []);

  async function loadNotes() {
    const data = await getNotes();
    setNotes(data);
  }
  // console.log(notes);

  //aabove is pulling notes from backend

  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below line for countdown for 5 prayers or u can say how much time remaining for next prayer🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽

  const [nextPrayer1, setNextPrayer1] = useState(null);
  const [countdown1, setCountdown1] = useState("");

  function timeToSeconds(str) {
    const chars = Array.from(str);
    const colonIndex = chars.indexOf(":");
    const h = Number(chars.slice(0, colonIndex).join(""));
    const m = Number(chars.slice(colonIndex + 1).join(""));
    return h * 3600 + m * 60;
  }

  const order = [
    "fajrIqamah",
    "dhuhrIqamah",
    "asrIqamah",
    "maghribIqamah",
    "ishaIqamah",
  ];

  // Step 1: find the next prayer time
  function getNextPrayer() {
    const now = new Date();
    const nowSec =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    for (let i = 0; i < order.length; i++) {
      const key = order[i];
      const targetSec = data && timeToSeconds(data[key]);
      if (targetSec > nowSec) {
        return key;
      }
    }
    // if past isha, loop back to fajr
    return "fajrIqamah";
  }

  // Step 2: update countdown every second
  useEffect(() => {
    function tick() {
      const key = data && getNextPrayer();
      setNextPrayer1(key);

      const now = new Date();
      const nowSec =
        now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      const targetSec = data && timeToSeconds(data[key]);

      // if target is tomorrow (after isha), add 24h
      const diffSec =
        targetSec > nowSec
          ? targetSec - nowSec
          : 24 * 3600 - nowSec + targetSec;

      const h = Math.floor(diffSec / 3600);
      const m = Math.floor((diffSec % 3600) / 60);
      const s = diffSec % 60;

      // format with leading zeros
      const hh = String(h).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      const ss = String(s).padStart(2, "0");

      setCountdown1(`${hh}:${mm}:${ss}`);
    }

    tick(); // run immediately
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, [data]);

  function removeIqamah(key) {
    return key?.endsWith("Iqamah")
      ? key?.slice(0, -"Iqamah".length) // remove last 6 chars
      : key;
  }

  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above line for countdown for 5 prayers or u can say how much time remaining for next prayer 🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  const [isVisible, setIsVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [hijriDate, setHijriDate] = useState("");
  const audioRef = useRef(null);

  //below code find what is the day today
  // const [dayName, setDayName] = useState(() => {
  //   const today = new Date();
  //   return today.toLocaleDateString("en-US", { weekday: "long" });
  // });

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     const today = new Date();
  //     setDayName(today.toLocaleDateString("en-US", { weekday: "long" }));
  //   }, 60000); // Update every minute

  //   return () => clearInterval(interval);
  // }, []);
  //above  code find what is the day today

  //below finds todays date and todays data to display🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  //excel formate find todays date below

  // function dateToExcelSerial(date = new Date()) {
  //   const excelStartDate = new Date(1900, 0, 1); // Jan 1, 1900
  //   const utcDate = Date.UTC(
  //     date.getFullYear(),
  //     date.getMonth(),
  //     date.getDate()
  //   );
  //   const utcStart = Date.UTC(
  //     excelStartDate.getFullYear(),
  //     excelStartDate.getMonth(),
  //     excelStartDate.getDate()
  //   );

  //   const diffInDays = Math.floor((utcDate - utcStart) / (1000 * 60 * 60 * 24));
  //   return diffInDays + 1;
  // }
  // const todaySerial = dateToExcelSerial(); // returns 45663 on April 20, 2025
  // const todaySerial2 = dateToExcelSerial() + 1; // returns 45664 on April 21, 2025
  // const todaySerial3 = dateToExcelSerial() + 2; // returns 45665 on April 22, 2025
  // const todaySerial4 = dateToExcelSerial() + 3; // returns 45666 on April 23, 2025
  // console.log("Today in Excel format:", todaySerial);
  // console.log("Tomorrow in Excel format:", todaySerial2);
  // console.log("Tomorrow in Excel format:", todaySerial3);
  // console.log("Tomorrow in Excel format:", todaySerial4);
  //excel formate find todays date above

  // const todaysItems = ddata.filter((item) => item.Date === todaySerial + 1);
  // const todaysItems2 = ddata.filter((item) => item.Date === todaySerial2 + 1);
  // const todaysItems3 = ddata.filter((item) => item.Date === todaySerial3 + 1);
  // const todaysItems4 = ddata.filter((item) => item.Date === todaySerial4 + 1);
  // console.log(todaysItems);

  // const [bb] = todaysItems;
  // const [bb2] = todaysItems2;
  // const [bb3] = todaysItems3;
  // const [bb4] = todaysItems4;
  //main data has all data inside bb
  // console.log(bb);

  //   delete bb.Day;

  // const keys_to_keep = [
  //   "Fajr",
  //   "Fajr_Iqamah",
  //   "Dhuhr",
  //   "Dhuhr_Iqamah",
  //   "Asr",
  //   "Asr_Iqamah",
  //   "Maghrib",
  //   "Maghrib_Iqamah",
  //   "Isha",
  //   "Isha_Iqamah",
  // ];

  // const klk = [data];
  // const keys_to_keep3 = [
  //   "fajrIqamah",
  //   "dhuhrIqamah",
  //   "asrIqamah",
  //   "maghribIqamah",
  //   "ishaIqamah",
  // ];

  // var result =
  //   klk &&
  //   klk.map((obj) =>
  //     Object.fromEntries(
  //       keys_to_keep3
  //         .map((key) => obj && obj.hasOwnProperty(key) && [key, obj[key]])
  //         .filter(Boolean)
  //     )
  //   );
  // const [ll] = result;
  // console.log(ll);

  // const keys_to_keep2 = [
  //   "Fajr_Iqamah",
  //   "Dhuhr_Iqamah",
  //   "Asr_Iqamah",
  //   "Maghrib_Iqamah",
  //   "Isha_Iqamah",
  // ];

  // var result = todaysItems.map((obj) =>
  //   Object.fromEntries(
  //     keys_to_keep2
  //       .map((key) => obj.hasOwnProperty(key) && [key, obj[key]])
  //       .filter(Boolean)
  //   )
  // );
  // const [kk] = result;
  // console.log(kk);
  //   // only 5 times azan data
  //up finds todays date and todays data to display🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽 count down for 5 prayers below🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // const [nextPrayer, setNextPrayer] = useState({});
  // const [countdown, setCountdown] = useState("00:00:00");
  const [isPlayingAzan, setIsPlayingAzan] = useState(false);
  //below finds next fiday
  // const nextFriday = getNextFriday();
  // const excelDate = dateToExcelSerial(nextFriday);
  // console.log(excelDate);
  //above finds next fiday
  // const nextFridayIs = ddata.filter((item) => item.Date === excelDate);
  // const [nextFridayInExcel] = nextFridayIs.map((a) => a.Date);
  //   console.log(nextFridayInExcel);
  // const [nextFridayInExcelToObject] = ddata.filter(
  //   (item) => item.Date === nextFridayInExcel
  // );
  // const fridayExcelToRegular = nextFridayInExcelToObject.Date;
  // const convertedDate = excelDateToJSDate(fridayExcelToRegular);
  // const formatted = convertedDate.toLocaleDateString("en-US", {
  //   year: "numeric",
  //   month: "long",
  //   day: "numeric",
  // });

  // const a = new Date();
  // const localDateString = today.toLocaleDateString();
  //   const today = a.toISOString().split("T")[0];
  // const todaysDateIs = a.toLocaleDateString("en-US", {
  //   year: "numeric",
  //   month: "long",
  //   day: "numeric",
  // });
  // console.log(a);
  // const tomorrow = new Date(a);
  // tomorrow.setDate(a.getDate() + 1);
  // console.log(tomorrow.toDateString());

  // const DayAfterTomorrow = new Date(a);
  // DayAfterTomorrow.setDate(a.getDate() + 2);
  // console.log(DayAfterTomorrow.toDateString());

  // const DayAfterTomorrowTomorrow = new Date(a);
  // DayAfterTomorrowTomorrow.setDate(a.getDate() + 3);
  // console.log(DayAfterTomorrowTomorrow.toDateString());

  // const DayAfterTomorrowTomorrowTomorrow = new Date(a);
  // DayAfterTomorrowTomorrowTomorrow.setDate(a.getDate() + 4);
  // console.log(DayAfterTomorrowTomorrowTomorrow.toDateString());

  // const DayAfterTomorrowTomorrowTomorrowTomorrow = new Date(a);
  // DayAfterTomorrowTomorrowTomorrowTomorrow.setDate(a.getDate() + 5);
  // console.log(DayAfterTomorrowTomorrowTomorrowTomorrow.toDateString());

  //   console.log(todaysDateIs);

  // const convertToMinutes = (excelTime) => excelTime * 24 * 60;

  // const formatTimeAMPM = (excelTime) => {
  //   const totalMinutes = convertToMinutes(excelTime);
  //   const hours = Math.floor(totalMinutes / 60);
  //   const minutes = Math.round(totalMinutes % 60);
  //   const h = hours % 12 || 12;
  //   const m = String(minutes).padStart(2, "0");
  //   const suffix = hours >= 12 ? "PM" : "AM";
  //   return `${h}:${m} ${suffix}`;
  // };

  // Convert "HH:MM" into total minutes
  // function timeToMinutes(timeStr) {
  //   const chars = Array.from(timeStr);
  //   const colonIndex = chars.indexOf(":");
  //   const hours = Number(chars.slice(0, colonIndex).join(""));
  //   const minutes = Number(chars.slice(colonIndex + 1).join(""));
  //   return hours * 60 + minutes;
  // }

  // useEffect(() => {
  //   // console.log(kk);
  //   const prayerList =
  //     Object &&
  //     Object.entries(kk).map(([label, time]) => ({
  //       label,
  //       time,
  //       minutes: convertToMinutes(time),
  //     }));
  //   // console.log(prayerList);
  //   const interval = setInterval(() => {
  //     if (isPlayingAzan) return;

  //     const now = new Date();
  //     const nowMinutes =
  //       now.getHours() * 60 + now.getMinutes() + now.getSeconds() / 60;

  //     let next = null;
  //     let minDiff = Infinity;

  //     for (let p of prayerList) {
  //       let diff = p.minutes - nowMinutes;
  //       if (diff < 0) diff += 1440;
  //       if (diff < minDiff) {
  //         minDiff = diff;
  //         next = p;
  //       }
  //     }

  //     const totalSeconds = Math.floor(minDiff * 60);

  //     if (totalSeconds <= 0) {
  //       // Countdown reached zero, play azan
  //       // playAzan(() => {
  //       //   // After azan, re-run logic to find next prayer
  //       //   const updatedNow = new Date();
  //       //   const updatedNowMinutes =
  //       //     updatedNow.getHours() * 60 + updatedNow.getMinutes();
  //       //   let upcoming = prayerList.find(
  //       //     (p) => convertToMinutes(p.time) > updatedNowMinutes
  //       //   );
  //       //   if (!upcoming) upcoming = prayerList[0]; // loop to Fajr
  //       //   setNextPrayer(upcoming);
  //       // });
  //     } else {
  //       setNextPrayer(next);
  //       const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  //       const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
  //         2,
  //         "0"
  //       );
  //       const s = String(totalSeconds % 60).padStart(2, "0");
  //       setCountdown(`${h}:${m}:${s}`);
  //     }
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [isPlayingAzan]);

  //below is for per second for NOW Clock🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  //below is Now er next line ta holo per second update er jonno
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);
  //above is Now er next line ta holo per second update er jonno
  //above is Now er next line ta holo per second update er jonno

  //below is for arabic date🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  useEffect(() => {
    const today = new Date();
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      calendar: "islamic",
      numberingSystem: "latn",
    };
    const hijriFormatter = new Intl.DateTimeFormat("en-US", options);
    const formattedHijri = hijriFormatter.format(today);
    setHijriDate(formattedHijri);
  }, []);
  //above is for arabic date

  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  // below is for change the background to dark blue when preyer time thrashhold finishes 🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽
  const [currentPrayer, setCurrentPrayer] = useState("");
  useEffect(() => {
    const checkPrayer = () => {
      const today = new Date();
      const todayDate = today.toLocaleDateString("en-US"); // "12/14/2025"
      // Your dataset uses "12/14/25" instead of "2025"
      const todayShort = todayDate.replace(/(\d+)$/, (y) => y.slice(-2)); // "12/14/25"
      // console.log(todayShort);
      // Find today's row
      // Normalize both to the same format
      function normalizeDate(str) {
        const [month, day, year] = str.split("/");
        return `${Number(month)}/${Number(day)}/${year}`;
      }

      const todayData =
        data && normalizeDate(data.date) === normalizeDate(todayShort);
      // console.log(data && data);
      // console.log(todayData);
      // console.log(data);

      // console.log(todayData.Fajr);
      // console.log(data && data?.fajr);

      // console.log(timeToSeconds(todayData.Fajr));
      // console.log(
      //   data?.fajr && data.fajr !== "null" && data?.fajr.trim() !== ""
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(
      //   data?.fajr?.includes(":")
      //     ? data?.fajr
      //         .split(":")
      //         .map(Number)
      //         .reduce((acc, v, i) => acc + v * (i ? 60 : 3600), 0)
      //     : null
      // );
      // console.log(todayData);

      function timeToSeconds(timeStr) {
        const [h, m] = timeStr && timeStr.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      const fajr = data && timeToSeconds(data?.fajr);
      // console.log(fajr);

      const dhuhr = data && timeToSeconds(data?.dhuhr);
      // console.log(dhuhr);

      const asr = data && timeToSeconds(data?.asr);
      // console.log(asr);

      const maghrib = data && timeToSeconds(data?.maghrib);
      // console.log(maghrib);

      const isha = data && timeToSeconds(data?.isha);
      // console.log(isha);

      const nowSec =
        today.getHours() * 3600 + today.getMinutes() * 60 + today.getSeconds();

      // console.log(nowSec);

      if (nowSec >= fajr && nowSec < dhuhr) {
        setCurrentPrayer("Fajr");
      } else if (nowSec >= dhuhr && nowSec < asr) {
        setCurrentPrayer("Dhuhr");
      } else if (nowSec >= asr && nowSec < maghrib) {
        setCurrentPrayer("Asr");
      } else if (nowSec >= maghrib && nowSec < isha) {
        setCurrentPrayer("Maghrib");
      } else {
        // Isha until next day's Fajr
        setCurrentPrayer("Isha");
      }
    };

    checkPrayer();
    const interval = setInterval(checkPrayer, 1000);
    return () => clearInterval(interval);
  }, [data]);

  // console.log(currentPrayer);

  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  // above is for change the background to dark blue when preyer time thrashhold finishes or changes🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //below useeffect will refresh page everyday at 12:05AM

  useEffect(() => {
    // Function to get the next 12:05 AM
    const getNextRefreshTime = () => {
      const now = new Date();
      const next = new Date();
      next.setHours(0, 5, 0, 0); // 12:05 AM today
      // next.setHours(19, 35, 0, 0);
      if (now > next) {
        next.setDate(next.getDate() + 1); // if past 12:05, schedule for tomorrow
      }
      return next;
    };

    const nextRefresh = getNextRefreshTime();
    const timeUntilRefresh = nextRefresh.getTime() - Date.now();

    const timer = setTimeout(() => {
      window.location.reload();
    }, timeUntilRefresh);

    return () => clearTimeout(timer);
  }, []);

  //above useeffect will refresh page everyday at 12:05AM

  // const [now, setNow] = useState(new Date());
  // const [activeWindow, setActiveWindow] = useState(null); // { prayerName, day, start, end }
  // const beepPlayed = useRef(false);

  // tick every second
  // useEffect(() => {
  //   const id = setInterval(() => setNow(new Date()), 1000);
  //   return () => clearInterval(id);
  // }, []);

  // remaining seconds for overlay
  // const remainingSeconds = activeWindow
  //   ? Math.max(
  //       0,
  //       Math.ceil((activeWindow.end.getTime() - now.getTime()) / 1000)
  //     )
  //   : 0;

  // below is for black screen for 10 minutes at prayer time🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻
  // below is for black screen for 10 minutes at prayer time🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽🔻⏬🔽    🔻

  // below is for black screen for 10 minutes at prayer time🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝
  function timeToSeconds(str) {
    const [h, m] = str.split(":").map(Number);
    return h * 3600 + m * 60;
  }
  const [blackout, setBlackout] = useState(false);
  const [remaining, setRemaining] = useState(0);

  // durations in minutes
  const durations = {
    fajrIqamah: 20,
    dhuhrIqamah: 15,
    asrIqamah: 15,
    maghribIqamah: 20,
    ishaIqamah: 20,
  };

  useEffect(() => {
    if (!data) return;

    const now = new Date();
    const todaySeconds =
      now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

    Object.entries(durations).forEach(([key, minutes]) => {
      const targetSeconds = timeToSeconds(data[key]);
      const delay = (targetSeconds - todaySeconds) * 1000;

      if (delay > 0) {
        setTimeout(() => {
          const weekday = now.toLocaleDateString(undefined, {
            weekday: "long",
          });

          if (key === "dhuhrIqamah" && weekday === "Friday") {
            triggerBlackout(60);
          } else {
            triggerBlackout(minutes);
          }
        }, delay);
      }
    });
  }, [data]);

  function triggerBlackout(minutes) {
    setBlackout(true);
    setRemaining(minutes * 60);

    const interval = setInterval(() => {
      setRemaining((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setBlackout(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  // format remaining seconds as HH:MM:SS
  function formatTime2(sec) {
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(
      2,
      "0",
    )}:${String(s).padStart(2, "0")}`;
  }
  // above is for black screen for 10 minutes at prayer time🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝🔚🔚🔚🔚🔝🔝🔝❌❌❌❌🔚🔚🔚🔚🔝🔝🔝

  //  // below Refresh the page a few seconds before the iqamah time.
  //below Play azan exactly at the iqamah time.
  // function timeToSeconds1(str) {
  //   const [h, m] = str.split(":").map(Number);
  //   return h * 3600 + m * 60;
  // }
  // useEffect(() => {
  //   if (!data) return;

  //   const now = new Date();
  //   const todaySeconds =
  //     now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

  //   // mapping of iqamah times to refresh offsets
  //   const refreshOffsets = {
  //     fajrIqamah: 10,
  //     dhuhrIqamah: 11,
  //     asrIqamah: 12,
  //     maghribIqamah: 13,
  //     ishaIqamah: 14,
  //   };

  //   Object.entries(refreshOffsets).forEach(([key, offset]) => {
  //     const targetSeconds = timeToSeconds1(data[key]);
  //     const delayToIqamah = (targetSeconds - todaySeconds) * 1000;

  //     if (delayToIqamah > 0) {
  //       // Refresh before iqamah
  //       const refreshDelay = delayToIqamah - offset * 1000;
  //       if (refreshDelay > 0) {
  //         setTimeout(() => {
  //           window.location.reload();
  //         }, refreshDelay);
  //       }

  //       // Azan exactly at iqamah
  //       setTimeout(() => {
  //         playAzan();
  //       }, delayToIqamah);
  //     }
  //   });
  // }, [data]);

  // function playAzan() {
  //   // Example: play audio file
  //   const audio = new Audio(IQAMAH); // put azan file in public folder
  //   audio.play();
  // }
  //  // above Refresh the page a few seconds before the iqamah time.
  //above Play azan exactly at the iqamah time.

  // below fetch breaking news from API
  // below fetch breaking news from API
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchItems().then((all) => setItems(all.filter((i) => i.visible)));
  }, []);
  // console.log(items);
  // above fetch breaking news from API
  // above fetch breaking news from API

  const [isVisible1, setIsVisible1] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible1((prevIsVisible) => !prevIsVisible);
    }, 1000); // Toggle visibility every 500ms

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
    <>
      <div className="page">
        <header className="header">
          <h2
            style={{
              marginTop: "-5px",
              letterSpacing: "4px",
              // fontSize: "18px",
              fontFamily: "Quicksand, sans-serif",
              fontWeight: "bold",
            }}
          >
            {" "}
            MIDDLETOWN ISLAMIC CENTER (NEW YORK)
          </h2>
          <p
            style={{
              marginTop: "-17px",
              marginBottom: "-4px",
            }}
          >
            169 Ryerson Rd, New Hampton, NY 10958 <br /> (845) 374-2190
          </p>
        </header>
        <main className="content">
          <section className="card">
            <div>
              <div
                className="Table-Title-div"
                style={{
                  marginTop: "5px",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    fontSize: "20px",
                    // border: "2px solid #000000ff",

                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "10%",

                        // background: "#80CBC4",
                      }}
                    ></td>

                    <td
                      style={{
                        width: "55%",
                        textAlign: "center",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      ATHAN
                    </td>

                    <td
                      style={{
                        width: "15%",
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "center",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                        fontWeight: "bold",
                      }}
                    >
                      IQAMAH
                    </td>
                  </tr>
                </table>
              </div>
              <div
                className={`box ${
                  currentPrayer === "Fajr" ? "active bestseller" : ""
                }`}
              >
                <table
                  style={{
                    width: "100%",

                    fontSize: "30px",
                    height: "35px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "20%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",

                        // background: "#80CBC4",
                      }}
                    >
                      <b></b> FAJR
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",
                        height: "19px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* 56:56 PM <br /> */}
                      {/* {formatTimeAMPM(bb.Fajr)}
                       */}
                      {data && format12h(data?.fajr)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Fajr_Iqamah)} */}
                      {data && format12h(data?.fajrIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
              <div
                className={`box ${
                  currentPrayer === "Dhuhr" ? "active bestseller" : ""
                }`}
              >
                <table
                  style={{
                    width: "100%",

                    fontSize: "30px",
                    height: "35px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "19.5%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",

                        // background: "#80CBC4",
                      }}
                    >
                      <b></b>DHUHR
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Dhuhr)} */}
                      {data && format12h(data?.dhuhr)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",
                        height: "10px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Dhuhr_Iqamah)} */}
                      {data && format12h(data?.dhuhrIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
              <div
                className={`box ${
                  currentPrayer === "Asr" ? "active bestseller" : ""
                }`}
              >
                <table
                  style={{
                    width: "100%",
                    fontSize: "30px",
                    height: "35px",

                    fontSize: "30px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "19.5%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",
                      }}
                    >
                      <b></b>ASR
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Asr)} */}
                      {data && format12h(data?.asr)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",

                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Asr_Iqamah)} */}
                      {data && format12h(data?.asrIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
              <div
                className={`box ${
                  currentPrayer === "Maghrib" ? "active bestseller" : ""
                }`}
              >
                <table
                  style={{
                    width: "100%",
                    fontSize: "30px",
                    height: "35px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "19.5%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",
                      }}
                    >
                      <b></b>MAGRIB
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Maghrib)} */}
                      {data && format12h(data?.maghrib)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",

                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Maghrib_Iqamah)} */}
                      {data && format12h(data?.maghribIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
              <div
                className={`box ${
                  currentPrayer === "Isha" ? "active bestseller" : ""
                }`}
              >
                <table
                  style={{
                    width: "100%",
                    fontSize: "30px",
                    height: "35px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "19.5%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",
                      }}
                    >
                      ISHA
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Isha)} */}
                      {data && format12h(data?.isha)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",
                        height: "10px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                      }}
                    >
                      {/* {formatTimeAMPM(bb.Isha_Iqamah)} */}
                      {data && format12h(data?.ishaIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
              <div className="box">
                <table
                  style={{
                    width: "100%",

                    fontSize: "30px",
                    border: "none !important",
                    marginTop: "-2px",
                    border: "none !important",
                    // filter: "drop-shadow(0 0 2px #6F47D3)",
                  }}
                >
                  <tr style={{}}>
                    <td
                      style={{
                        width: "10%",
                        fontFamily: "Quicksand, sans-serif",
                        fontWeight: "bold",
                        textAlign: "right",
                        fontSize: "25px",
                        verticalAlign: "top",
                      }}
                    >
                      JUMUAH
                    </td>

                    <td
                      style={{
                        width: "45%",
                        fontSize: "30px",
                        // letterSpacing: -4,
                        fontFamily: "Quicksand, sans-serif",
                        textAlign: "right",

                        fontWeight: "bold",
                        height: "10px",
                        // border: "1px solid #dddddd",
                        // background: "#80CBC4",
                      }}
                    >
                      {/* 1:00 PM */}
                      {data && format12h(data?.jumuah)}
                    </td>

                    <td
                      style={{
                        width: "45%",
                        textAlign: "right",
                        fontWeight: "bold",
                        fontSize: "30px",
                        height: "10px",
                        // letterSpacing: -4,

                        fontFamily: "Quicksand, sans-serif",
                        borderRight: "1px solid #dddddd",
                        borderLeft: "1px solid #dddddd",
                      }}
                    >
                      {data && format12h(data?.jumuahIqamah)}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </section>
          <section className="card">
            <div
              style={
                {
                  // marginBottom: "-15px",
                }
              }
            >
              <h4
                style={{
                  marginTop: "2px",
                  textAlign: "center",
                  marginBottom: "15px",
                }}
              >
                IQAMAH UPDATED/ UPDATED NEWS
              </h4>

              <ol
                style={{
                  marginTop: "-11px",
                  // textAlign: "center",
                  // marginBottom: "-35px",
                  marginRight: "40px",
                  // alignItems: "center",
                }}
              >
                {/* {notes.map((note, index) => (
                  <li key={index}>{note.text}</li>
                ))} */}
                {items.length > 0
                  ? items.map((note, index) => (
                      <li
                        style={{
                          color: "red",
                          fontSize: "17px",
                          opacity: isVisible1 ? 1 : 0, // Control visibility with opacity
                          transition: "opacity 0.2s ease-in-out", // Smooth transition for blinking
                          alignItems: "center",
                        }}
                        key={index}
                      >
                        {note.text}
                      </li>
                    ))
                  : "No Updates Available"}
              </ol>

              {/* {items.map((item) => (
                <div key={item._id}>{item.text}</div>
              ))} */}
            </div>
          </section>
          <section className="card">
            <h4
              style={{
                marginTop: "1px",

                textAlign: "center",
              }}
            >
              Outside TV Scrolling News
            </h4>

            <div
              style={{
                marginTop: "-35px",

                display: "flex",
                alignItems: "center",
              }}
            >
              <ol
                style={
                  {
                    // marginBottom: "-35px",
                  }
                }
              >
                {/* {notes.map((note, index) => (
                  <li key={index}>{note.text}</li>
                ))} */}
                {notes.length > 0
                  ? notes.map((note, index) => <li key={index}>{note.text}</li>)
                  : "No Notes Available"}
              </ol>
            </div>
          </section>
        </main>
        <footer
          style={
            {
              // marginTop: "-20px",
            }
          }
          className="footer"
        >
          © 2025 Mehdi Hasan
        </footer>

        {/* CSS in the same page */}
        <style>
          {`
          .page {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            display: flex;
            flex-direction: column;
            min-height: 100vh;
            background: #f5f5f5;
          }
          .header {
            background: #1976d2;
            color: white;
            text-align: center;
            padding: 5px;
            // font-size: 1.5rem;
          }
          .content {
            flex: 1;
            display: grid;
            grid-template-columns: 1fr;
            gap: 15px;
            // padding: 15px;
          }
          .card {
            background: white;
            // padding: 20px;
            border-radius: 8px;
            box-shadow: 0 2px 5px rgba(0,0,0,0.1);
            // font-size: 1rem; 
          }
          .footer {
            background: #1976d2;
            color: white;
            text-align: center;
            // padding: 10px;
            font-size: 0.9rem;
          }
            
.icon-image {
  // width: 24px; 
  // height: 24px;
}

.word {
  // font-size: 24px;
  // font-weight: bold;
}
.box {
 
  background-color: white;
  color: #0070bb;
  filter: drop-shadow(0 0 5px #6f47d3);

}

.box.active {
  background-color: #0070bb;
  color: white;
}
.bestseller:after {
  content: "";
  z-index: 1;
  overflow: hidden;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  /* transform: rotate(45deg); */
  transform: rotate(-45deg);
  /* width: 120px; */
  width: 106px;
  display: block;
  background: #5b712a;
  background: linear-gradient(#9bc90d 0%, #79a70a 100%);
  /* background: linear-gradient(#c90d2c 0%, #db0808 100%); */

  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 20px;
  /* right: -22px; */
  left: -22px;
  clip-path: polygon(
    120px 35px,
    75px -15px,
    30px -10px,
    0px 10px,
    10px 100px,
    110px 30px
  );
}

          /* Responsive styles for larger screens */
          @media (min-width: 600px) {
            .content {
              grid-template-columns: 1fr 1fr;
            }
            .card {
              font-size: 1.1rem;
            }
          }

          @media (min-width: 900px) {
            .content {
              grid-template-columns: 1fr 1fr 1fr;
            }
            .card {
              font-size: 1.2rem;
            }
          }
        `}
        </style>
      </div>
    </>
  );
}
